import CompanyListPage from '@/pages/CompanyListPage.vue';
import CompanyDetailPage from '@/pages/CompanyDetailPage.vue';
import CompanyDepartmentListPage from '@/pages/CompanyDepartmentListPage.vue';
import CompanyEmployeeListPage from '@/pages/CompanyEmployeeListPage.vue';
import CompanySettingsPage from '@/pages/CompanySettingsPage.vue';
import CompanyAccessDescriptionPage from '@/pages/CompanyAccessDescriptionPage.vue';
import CrmPage from '@/pages/CrmPage.vue';

export default [
  {
    path: '/companies',
    name: 'company-list',
    component: CompanyListPage,
    meta: { title: 'Компании' },
  },
  {
    path: '/companies/:companyId',
    name: 'company-detail',
    component: CompanyDetailPage,
    children: [
      {
        path: 'departments',
        name: 'company-departments',
        component: CompanyDepartmentListPage,
      },
      {
        path: 'employees',
        name: 'company-employees',
        component: CompanyEmployeeListPage,
      },
      {
        path: 'description',
        name: 'company-description',
        component: CompanySettingsPage,
      },
      {
        path: 'access-description',
        name: 'company-access-description',
        component: CompanyAccessDescriptionPage,
      },
      // CRM — вкладка компании: лэйаут и меню компании даёт CompanyDetailPage,
      // сама страница рендерит только доску
      {
        path: 'crm',
        name: 'crm',
        component: CrmPage,
        meta: { title: 'CRM' },
        children: [
          // У шторки заявки собственный роут. Своего компонента у неё нет:
          // страница остаётся смонтированной, а шторку открывает и закрывает
          // сама CrmPage по параметру leadId
          {
            path: 'funnels/:funnelId/leads/:leadId',
            name: 'crm-lead',
            // meta детей не наследуется от родителя, а заголовок ставится по нему:
            // без этого на роуте заявки во вкладке осталось бы название прошлой страницы
            meta: { title: 'CRM' },
          },
        ],
      },
    ],
  },
];
